import { persisted } from "svelte-persisted-store";
import type { Writable } from "svelte/store";
import type { TermsItem } from "./TermsItem";

const confirmKey = "confirm";
export const termsStore = persisted(confirmKey, {
  confirmed: "",
}) as Writable<TermsItem>;
